var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#ey_svg__clip0_13385_3053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 10.119c1.962 0 3.873-.003 5.784.007.134 0 .326.07.39.167.43.653.833 1.322 1.304 2.082h-4.23v1.61h3.779v2.1h-3.78v1.7h4.101c.808 0 1.212.376 1.212 1.128V20H.5v-9.881zM7.682 10.065c1.09 0 2.152-.015 3.212.017.15.004.337.218.429.375.534.916 1.045 1.844 1.605 2.841.553-.983 1.082-1.883 1.565-2.804.173-.33.379-.453.77-.442.962.024 1.925.007 3 .007-.149.26-.24.434-.345.6-1.03 1.652-2.073 3.295-3.082 4.957a2.075 2.075 0 00-.286.977c-.034 1.097-.013 2.196-.013 3.325H11.32c0-.497-.053-1.009.01-1.508.207-1.627-.273-3.04-1.261-4.387-.875-1.194-1.583-2.496-2.362-3.75-.017-.029-.01-.07-.025-.208zM.5 7.065L21.5 0v3.643L.5 7.065z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ey_svg__clip0_13385_3053"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h21v20H0z"
  })))));
}
export default SvgEy;